import { Typography, InputAdornment, TextField, Paper, Snackbar, makeStyles, TableCell, MuiThemeProvider, createMuiTheme, Tooltip, withStyles, Switch } from '@material-ui/core'
import React, { useEffect, useReducer, useState } from 'react'
import ic_search from '../../assets/ic_search.png';
import CloseIcon from '@material-ui/icons/Close';
import api from '../api'
import MuiAlert from '@material-ui/lab/Alert';
import MUIDataTable from "mui-datatables";
import Autocomplete from '@material-ui/lab/Autocomplete';
import editIcon from '../../assets/1@3x.png';
import AddMasterJadwal from './addJadwalTelekonsul';
import EditMasterJadwal from './editJadwalTelekonsul';
import icCircle from '../../assets/circle.png';
import icSeru from '../../assets/ic_exclamation.png';
import Loader from 'react-loader-spinner'
import { format } from 'date-fns';


const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTableMasterJadwal());
const options = ct.customOptions()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const style = {
    position: "sticky",
    zIndex: 10
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

export default function JadwalTelemedicine(props) {
    const [listDokter, setListDokter] = useState([])
    const [pickDokter, setpickDokter] = useState(null);
    const [visibleSearch, setVisibleSearch] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [visibleDetail, setVisibleDetail] = React.useState(false)
    const [visibleCreate, setVisibleCreate] = React.useState(false)
    const [visibleStatus, setVisibleStatus] = useState(false)
    const [selectedData, setSelectedData] = React.useState(null);
    const [value, setValue] = React.useState(null);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const classes = useStyles()
    const [dataTable, setDataTable] = React.useState([])
    const [id, setID] = React.useState("")
    const [detail, setDetail] = useState([])
    const [telemedID, setTelemedID] = React.useState(null);

    const forceUpdate = useReducer(bool => !bool)[1];

    useEffect(() => {
        getAllDokter()
    }, [])

    useEffect(() => {
        pickDokter && getDataTable()
    }, [pickDokter])


    const getAllDokter = () => {
        api.create().getJadwalTransaksiTelemedicine().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setListDokter(data)
                }
            }
        })
    }

    const createJadwal = (payload) => {
        api.create().createJadwalTelemedicine(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("Success")
                    setVisibleCreate(false)
                    getDataTable()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("Warning")
                    }
                }
            }
        })
    }

    const editJadwal = (payload) => {
        api.create().editMasterJadwalTelemedicine(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("Success")
                    setVisibleDetail(false)
                    getDataTable()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("Warning")
                    }
                }
            }
        })
    }

    const changeStatus = () => {
        let payload = {
            "id": detail[9],
            "activeinactive": detail[8] === "Active" ? 0 : 1
        }
        api.create().editMasterJadwalTelemedicine(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setVisibleStatus(false)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    getDataTable()
                }
            }
        })
    }


    const doFilter = (keyword) => {
        let param = `keyword=${keyword}`
        if (keyword === null || keyword === "") {
            getAllDokter()
        } else {
            api.create().getListMasterDokterFilter(param).then(response => {
                console.log(response)
                if (response.data) {
                    if (response.data.status === true) {
                        let data = []
                        response.data.data.map((item) => {
                            if (item.deleted_at === null) {
                                data.push(item)
                            }
                        })
                        setListDokter(data)
                    } else {
                        setListDokter([])
                    }
                }
                setLoading(false)
            })
        }
    }

    const handleClick = (item) => {
        setSelectedData(item)
    }

    const handleStatus = ({ rowData }) => {
        setVisibleStatus(true)
        setDetail(rowData)
    }

    const handleSeeDetail = (data) => {
        setID(data.rowData[9])
        setVisibleDetail(true)
    }

    const getDataTable = (item) => {
        api.create().getJadwalTelemedicine(pickDokter?.doctor_telemedicine_id).then(response => {
            console.log(response, item)
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let dataTable = []
                        if (response.data.data[0].schedule.length > 0) {
                            response.data.data[0].schedule.map((items) => {
                                if (items.schedule_date.length > 0) {
                                    items.schedule_date.map((itemss) => {
                                        if (itemss.schedule_detail.length > 0) {
                                            itemss.schedule_detail.map((itemsss, idx) => {
                                                dataTable.push([
                                                    idx + 1,
                                                    response.data.data[0]?.name,
                                                    itemss.date,
                                                    items.type,
                                                    itemsss.hari,
                                                    itemsss.time_start,
                                                    itemsss.time_end,
                                                    items.type === "Reservasi" ? itemsss.time_start : "-",
                                                    itemsss.deleted_at === null ? 'Active' : 'Inactive',
                                                    itemsss.id,
                                                    response.data.data[0]?.doctor_telemedicine_id
                                                ])
                                            })
                                        }
                                    })
                                }
                            })
                            // if (items.effective_date.length > 0) {
                            //     items.effective_date.map((itemss) => {
                            //         if (itemss.schedule_detail.length > 0) {
                            //             itemss.schedule_detail.map((itemsss, idx) => {
                            //                 dataTable.push([
                            // idx + 1,
                            // response.data.data[0]?.name,
                            // itemss.date,
                            // items.type,
                            // itemsss.hari,
                            // itemsss.time_start,
                            // itemsss.time_end,
                            // items.type === "Reservasi" ? itemsss.time_start : "-",
                            // itemsss.deleted_at === null ? 'Active' : 'Inactive',
                            // itemsss.id,
                            // response.data.data[0]?.doctor_telemedicine_id
                            //                 ])
                            //             })

                            //         }
                            //     })
                            // }
                        }
                        setDataTable(dataTable)
                        forceUpdate()
                    } else {
                        setDataTable([])
                        forceUpdate()
                    }

                }
            }
            setLoading(false)
        })
    }

    const handleSave = (item) => {
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const onClose = () => {
        setVisibleDetail(false)
        setVisibleCreate(false)
    }

    const columns = [{
        name: "No",
        options: {
            filter: false,
            sortThirdClickReset: true,
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ textAlign: 'center' }}>
                        {tableMeta.rowIndex + 1}
                    </div>
                )
            }
        }
    },
    {
        name: "",
        label: "Nama Dokter",
        options: {
            filter: false,
            sortThirdClickReset: true,
        }
    },
    {
        name: "",
        label: "Tanggal Berlaku",
        options: {
            sortThirdClickReset: true
        }
    },
    {
        name: "",
        label: "Tipe Jadwal",
        options: {
            sortThirdClickReset: true
        }
    },
    {
        name: "",
        label: "Hari",
        options: {
            sortThirdClickReset: true
        }
    },

    {
        name: "",
        label: "Jam Mulai",
        options: {
            sortThirdClickReset: true
        }
    },
    {
        name: "",
        label: "Jam Selesai",
        options: {
            sortThirdClickReset: true
        }
    },
    {
        name: "",
        label: "Jam Reservasi",
        options: {
            sortThirdClickReset: true
        }
    },
    {
        name: "",
        label: "Status",
        options: {
            sortThirdClickReset: true
        }
    },
    {
        name: "Aksi",
        options: {
            filter: false,
            customHeadRender: (columnMeta) => (
                <TableCell style={{ ...style, top: 0, backgroundColor: 'white', }}>
                    <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                let hour = format(new Date(), 'HHmmss')
                let date = format(new Date(), 'yyyy-MM-dd')
                let minHour = String(tableMeta.rowData[5]).split(':').join('')
                let maxHour = String(tableMeta.rowData[6]).split(':').join('')
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <LightTooltip title={`Edit`} arrow>
                            <button
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }
                                }
                                onClick={() => {
                                    console.log(date, tableMeta.rowData[2], hour, minHour, maxHour);
                                    if (date === tableMeta.rowData[2] && (Number(hour) > Number(minHour) && Number(hour) < Number(maxHour))) {
                                        setOpenAlert(true)
                                        setMessageAlert("Tidak dapat merubah jadwal saat sedang berlangsung")
                                        setStatusAlert("warning")
                                    } else {
                                        handleSeeDetail(tableMeta)
                                    }
                                }}
                            >
                                <img src={editIcon} style={{ width: 30, height: 30 }} />
                            </button>
                        </LightTooltip>
                        <LightTooltip title={`${tableMeta.rowData[8]}`} arrow>
                            <button style={{
                                backgroundColor: "transparent",
                                fontSize: 20,
                                outline: 'none',
                                borderColor: 'transparent'
                            }}
                                onClick={() => {
                                    handleStatus(tableMeta)
                                }}>
                                <IconSwitch checked={
                                    date === tableMeta.rowData[2] && (Number(hour) > Number(minHour) && Number(hour) < Number(maxHour)) ? false :
                                        tableMeta.rowData[8] === 'Active' ? true : false} />
                            </button>
                        </LightTooltip>
                    </div>
                )
            }
        }
    },
    {
        name: "",
        options: {
            display: false,
            filter: false
        }
    },
    {
        name: "",
        options: {
            display: false,
            filter: false
        }
    }];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const createCron = (e) => {
        console.log(telemedID);
        let payload = {
            "doctor_telemedicine_id": telemedID
        }
        // console.log(payload);
        api.create().createManualCronTelemed(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("Success")
                    getAllDokter(selectedData)
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("Warning")
                    }
                }
            }
        })
    }


    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {loading ? loadingComponent : null}
            {/* <div style={{ width: '25%', maxHeight: props.height - 100, overflow: 'scroll' }}>
                <Typography style={{ color: '#278863', marginTop: 20 }}>List Nama Dokter</Typography>
                <hr style={{ marginTop: 0 }} />
                {
                    !visibleSearch ?
                        <img title="cari dokter" onClick={() => setVisibleSearch(true)} src={ic_search} style={{ marginBottom: 10, cursor: 'pointer' }} />
                        :
                        <div style={{ marginTop: -10, marginBottom: 10 }}>
                            <TextField
                                label="Pencarian Dokter"
                                onChange={(e) => doFilter(e.target.value)}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                            <CloseIcon
                                                titleAccess="batal"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    doFilter(null)
                                                    setVisibleSearch(false)
                                                }}
                                            />
                                        </InputAdornment>
                                }}
                            />
                        </div>
                }
                {listDokter.length > 0 && listDokter.map((item, index) => {
                    return (
                        <div style={{ cursor: "pointer", margin: '5px 0' }}
                            onClick={() => {
                                handleClick(item)
                            }}>
                            <Typography style={{ color: selectedData && selectedData.doctor_id === item.doctor_id ? '#278863' : '#b4b4b4' }}>{item.name}</Typography>
                        </div>
                    )
                })}
            </div> */}
            <div style={{ width: '100%', margin: 10 }}>
                <Paper style={{ width: '100%', boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)', padding: 20, overflow: 'scroll', maxHeight: props.height - 100, height: '90vh' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Autocomplete
                            options={listDokter}
                            getOptionLabel={(option) => option.name}
                            disableClearable
                            style={{ width: 300 }}
                            onChange={(event, newInputValue) => {
                                setLoading(true)
                                handleClick(newInputValue)
                                setpickDokter(newInputValue)
                                // setJenis(newInputValue)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    label={'Pilih Dokter'}
                                />
                            }
                            value={pickDokter}
                        />
                        {selectedData && (
                            <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none', padding: '0 10px', alignSelf: 'center', height: 35 }}>
                                <div onClick={() => { setVisibleCreate(true) }} style={{ display: 'flex' }}>
                                    <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                                    <Typography style={{ fontSize: 13, margin: 'auto', color: 'white' }}>Tambah</Typography>
                                </div>
                            </button>
                        )}
                    </div>
                    <div style={{ width: '100%', margin: 5 }}>
                        <div>
                            <MuiThemeProvider theme={getMuiTheme()} style={{ maxHeight: props.height - 140 }}>
                                <MUIDataTable
                                    data={dataTable}
                                    columns={columns}
                                    options={options}
                                />
                            </MuiThemeProvider>
                        </div>
                    </div>
                    {/* {dataTable.length > 0 ?
                        <div >
                            
                        </div>
                        :
                        <div style={{ marginTop: 20 }}>
                            <Typography style={{ fontSize: 30 }}>Jadwal Tidak Tersedia</Typography>
                        </div>} */}
                </Paper>
            </div>

            {visibleCreate && (
                <AddMasterJadwal
                    onClose={onClose}
                    selectedData={selectedData}
                    getData={getDataTable}
                    createJadwal={(payload) => createJadwal(payload)}
                />
            )}

            {visibleDetail && (
                <EditMasterJadwal
                    onClose={onClose}
                    id={id}
                    getData={getDataTable}
                    editJadwal={(payload) => editJadwal(payload)}
                />
            )}

            {visibleStatus && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle" style={{ borderRadius: 15, width: 540, backgroundColor: '#f2fff9' }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ backgroundColor: '#f2fff9', margin: '-50px 0px 0px 0px', borderRadius: 70, width: 115, height: 115, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ backgroundImage: `url(${icCircle})`, width: 103.8, height: 103.8, backgroundRepeat: 'no-repeat', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={icSeru} style={{ width: 50, height: 50 }} />
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin mengganti status Jadwal Telemedicine tersebut?</Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '10px', padding: '20px' }}>
                            <div
                                onClick={() => setVisibleStatus(false)}
                                style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                            </div>
                            <div
                                onClick={() => changeStatus()}
                                style={{ height: 32, width: 150, backgroundColor: '#278863', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}